module.exports = __webpack_public_path__ + "img/logro3.94024b01.webp";